import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiKey } from "../../config/config";
// import { Link } from "react-router-dom";
import Table from "../../components/Table";

export default function InvestorDashboard({ lang = {} }) {
  const [investor, setInvestor] = useState(null);
  const [stats, setStats] = useState({ total_deposit: 0, total_withdraw: 0 });
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    const session = JSON.parse(sessionStorage.getItem("aman-investor") || "{}");
    const token = session.token;
    if (!token) return;

    const headers = { Authorization: `Bearer ${token}` };

    axios
      .get(`${apiKey}/investor-panel/dashboard`, { headers })
      .then((res) => {
        setInvestor(res.data.investor);
        setStats(res.data.stats || { total_deposit: 0, total_withdraw: 0 });
      })
      .catch((err) => console.error(err));

    axios
      .get(`${apiKey}/investor-panel/transactions`, { headers })
      .then((res) => {
        setTransactions(res.data.transactions || []);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const columns = [
    {
      header: lang["SN"] || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: lang["Tx_ID"] || "Tx ID",
      accessorKey: "id",
      cell: (row) => <span className="fw-bold text-primary">#{row.getValue()}</span>,
    },
    {
      header: lang["Type"] || "Type",
      accessorKey: "transaction_type",
      cell: (row) => {
        const type = row.getValue() || row.row.original.type;
        const isDep = type === "investor_deposit" || type === "deposit";
        return (
          <span className={`badge ${isDep ? "bg-success" : "bg-warning text-dark"}`}>
            {isDep ? "Deposit" : "Withdrawal"}
          </span>
        );
      },
    },
    {
      header: lang["Amount"] || "Amount (SAR)",
      accessorKey: "amount",
      cell: (row) => {
        const type = row.row.original.transaction_type || row.row.original.type;
        const isDep = type === "investor_deposit" || type === "deposit";
        return (
          <span className={`fw-bold ${isDep ? "text-success" : "text-danger"}`}>
            {isDep ? "+" : "-"} SAR {Number(row.getValue() || 0).toLocaleString()}
          </span>
        );
      },
    },
    {
      header: lang["Branch"] || "Branch",
      accessorKey: "branch_name",
      cell: (row) => row.getValue() || "Main Branch",
    },
    {
      header: lang["Date"] || "Date",
      accessorKey: "date",
      cell: (row) => (row.getValue() ? new Date(row.getValue()).toLocaleDateString() : "N/A"),
    },
  ];

  return (
    <div className="container-fluid px-4 py-3">
      <div className="pagetitle mb-4">
        <h1 className="fw-bold">{lang.Dashboard || "Investor Portfolio Dashboard"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">{lang.Home || "Home"}</li>
            <li className="breadcrumb-item active">{lang.Dashboard || "Dashboard"}</li>
          </ol>
        </nav>
      </div>

      {/* Stats Overview */}
      <div className="row g-3 mb-4">
        <div className="col-md-4">
          <div className="card shadow-sm border rounded-3 p-3 bg-white">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="text-muted small fw-bold">CURRENT BALANCE</span>
                <h3 className="fw-bold text-primary mb-0 mt-1">
                  SAR {investor?.balance ? Number(investor.balance).toLocaleString() : 0}
                </h3>
              </div>
              <div className="bg-light p-3 rounded-circle text-primary">
                <i className="fa fa-wallet fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card shadow-sm border rounded-3 p-3 bg-white">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="text-muted small fw-bold">TOTAL DEPOSITS</span>
                <h3 className="fw-bold text-primary mb-0 mt-1">
                  SAR {stats?.total_deposit ? Number(stats.total_deposit).toLocaleString() : 0}
                </h3>
              </div>
              <div className="bg-light p-3 rounded-circle text-primary">
                <i className="fa fa-arrow-down-left fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card shadow-sm border rounded-3 p-3 bg-white">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="text-muted small fw-bold">TOTAL WITHDRAWALS</span>
                <h3 className="fw-bold text-primary mb-0 mt-1">
                  SAR {stats?.total_withdraw ? Number(stats.total_withdraw).toLocaleString() : 0}
                </h3>
              </div>
              <div className="bg-light p-3 rounded-circle text-primary">
                <i className="fa fa-arrow-up-right fs-4"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Transactions Table */}
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="row pt-3">
                <div className="rr col-9">
                  {lang.Recent_Transactions || "Recent Investor Transactions"}
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex mt-3 mb-3">
                  <Table
                    columns={columns}
                    data={transactions}
                    lang={lang}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
